import { CapabilityFlags, CapabilitySelectors } from './types';

export const deriveCapabilitySelectors = (capabilities: CapabilityFlags): CapabilitySelectors => ({
  canViewAnalytics: capabilities.view_analytics,
  canCreateCustomReports: capabilities.create_custom_reports,
  canOpenUserDetails: capabilities.view_user_details,
  canViewSonarSection: capabilities.view_sonar_section,
  canViewPreferredContent: capabilities.view_preferred_content,
  canViewTopUsers: capabilities.view_top_users,
  canUsePlaylists: capabilities.use_playlists,
  canViewCertificationInsights: capabilities.view_certifications_table,
});
